import React, { useEffect, useState, useContext, useRef } from "react";
import { DateLogic } from "../../Container/dateLogic";
import { NavLink } from "react-router-dom";
import Message from "../Message/Message";
import useForm from "./useForm";
import Validate from "./validate";
import { ThemeDataContext } from "../../ContextProviders/theme";
import "./SignUpFormAtlantica.css";
import { BsEyeFill } from "react-icons/bs";
import CheckboxVerity from "../Checkbox/CheckboxVerity";
import toast, { Toaster, useToaster, useToasterStore } from "react-hot-toast";
import Exclamation from "../../Icons/Exclamation";
import { useMediaQuery } from "react-responsive";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

function SignUpForm({ submitForm }) {
    const [passwordShown, setPasswordShown] = useState(false);
    const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);
    const [minDate, setMinDate] = useState("");
    const [maxDate, setMaxDate] = useState("");

    const Tablet = useMediaQuery({
        query: "(min-width: 768px) ",
    });

    const Mobile = useMediaQuery({
        query: "(min-width: 280px) and (max-width: 767px)",
    });

    const togglePassword = () => {
        setPasswordShown(!passwordShown);
    };
    const toggleConfirmPassword = () => {
        setConfirmPasswordShown(!confirmPasswordShown);
    };

    const {
        handleChange,
        handleDateChange,
        handleSubmit,
        isSubmitting,
        setIsSubmitting,
        values,
        errors,
        setErrors,
        authErrors,
        setAuthErrors,
        isDisabled,
        birthdate,
    } = useForm(submitForm, Validate);

    const programLabel = localStorage.getItem("programLabel");
    const { portalInfo } = useContext(ThemeDataContext) || {};
    const { buttonBackgroundColor } = portalInfo || {};
    const { buttonColor } = portalInfo || {};

    const { termsFileUri } = portalInfo || {};
    console.log(termsFileUri, "terms");

    const style = {
        backgroundColor: `${buttonBackgroundColor}`,
        color: `${buttonColor}`,
    };

    const labelStyle = {
        color: "var(--color-th)",
        whiteSpace: "nowrap",
    };

    const formGridStyle = {
        display: Mobile ? "flex" : "grid",
        flexDirection: Mobile ? "column" : undefined,
        gridTemplateColumns: Mobile ? undefined : "1fr 1fr",
        gap: Mobile ? "1rem" : "2rem",
    };

    useEffect(() => {
        const dateRange = DateLogic.getBirthdateRange();
        setMinDate(dateRange.min);
        setMaxDate(dateRange.max);
    }, []);

    // const getClassName = () =>
    //   errors.length === 0 ? 'registerContainer' : 'registerContainerWithErrors';

    // function showPopup(termsFileUri) {
    //   newwindow = window.open(
    //     termsFileUri,
    //     'name',
    //     'height=190,width=520,top=200,left=300,resizable'
    //   );
    //   if (window.focus) {
    //     newwindow.focus();
    //   }
    // }

    const { toasts, handlers } = useToaster();

    const notifyError = (err) =>
        toast(
            <div
                style={{
                    display: "flex",
                    width: "100%",

                    borderRadius: "7px",
                    fontFamily: "Lato",
                    filter: "drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.25))",
                    background: "transparent",
                    color: `black`,
                }}
            >
                <div
                    style={{
                        display: "flex",
                        order: "1",
                        alignItems: "center",
                        width: "20%",
                        transform: "translateX(-10%)",
                    }}
                >
                    <Exclamation
                        width="50"
                        height="50"
                        viewBox="-4 1 25 15"
                        color="red"
                    />
                </div>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        order: "2",
                        width: "80%",
                        transform: "translateX(0%)",
                    }}
                >
                    {err}
                </div>
            </div>,
            {
                style: {
                    borderLeft: "6.5px solid red",
                    maxWidth: "400px",
                },
                duration: "60000",

                position: "top-center",
            },
        );
    const TOAST_LIMIT = 1;

    const notifyPassComposition = () =>
        toast.error(
            "Password must contain at least: 8 characters, 1 uppercase letter, 1 lowercase letter, 1 number, 1 symbol.",
        );

    const buttonRef = useRef();

    useEffect(() => {
        console.log(toasts, "toasts");
        toasts
            .filter((t) => t.visible) // Only consider visible toasts
            .filter((_, i) => i >= TOAST_LIMIT) // Is toast index over limit?
            .forEach((t) => toast.dismiss(t.id)); // Dismiss – Use toast.remove(t.id) for no exit animation
    }, [toasts]);

    useEffect(() => {
        if (errors.passwordComposition) {
            notifyPassComposition();
            setErrors({
                ...errors,
                passwordComposition: "",
            });
            setIsSubmitting(false);
            console.log(isSubmitting, "isSubmitting");
            buttonRef.current.disabled = true;
            setTimeout(() => (buttonRef.current.disabled = false), 3000);
        }
    }, [
        errors,
        notifyPassComposition,
        setErrors,
        isSubmitting,
        setIsSubmitting,
    ]);

    useEffect(() => {
        if (authErrors.length != 0) {
            notifyError(authErrors);
            setIsSubmitting(false);
            console.log(isSubmitting, "isSubmitting");
            setAuthErrors([]);
            buttonRef.current.disabled = true;
            setTimeout(() => (buttonRef.current.disabled = false), 3000);
        }
    }, [
        authErrors,
        notifyError,
        setAuthErrors,
        buttonRef,
        isSubmitting,
        setIsSubmitting,
    ]);

    const handleDismiss = () => {
        toasts.forEach((t) => toast.dismiss(t.id));
    };

    return (
        <>
            <div className="signUpHeading">
                <br />
                <br />

                <h1>Become a Member !</h1>
                <hr className="signUpLine" />
            </div>
            <Message message={authErrors} isError={true} />
            <div onClick={handleDismiss}>
                <Toaster
                    style={{ width: "500px" }}
                    position="top-center"
                    containerClassName="signUpToaster"
                    containerStyle={{
                        top: 10,
                        left: 10,
                        bottom: 10,
                        right: 10,
                    }}
                />
            </div>
            <form className="p-4 flex flex-col gap-4" onSubmit={handleSubmit}>
                <div style={formGridStyle}>
                    <div
                        className="flex flex-wrap flex-col"
                        style={{ gridColumn: "1 / -1" }}
                    >
                        <label htmlFor="email" style={labelStyle}>
                            Email*
                        </label>
                        <input
                            disabled={isDisabled}
                            id="email"
                            type="email"
                            name="email"
                            className="SignUp-form-emailInput w-full !ml-0"
                            placeholder=""
                            value={values.email}
                            onChange={handleChange}
                            style={{ margin: "0px 0px" }}
                        />
                        {errors.email && (
                            <p id="SignUp-email-error">{errors.email}</p>
                        )}
                    </div>

                    <div
                        className="flex flex-wrap flex-col"
                        style={{ gridColumn: Mobile ? "1 / -1" : "span 1" }}
                    >
                        <label htmlFor="firstname" style={labelStyle}>
                            First Name*
                        </label>
                        <input
                            disabled={isDisabled}
                            id="firstname"
                            type="text"
                            name="firstname"
                            className="SignUp-form-input w-full !ml-0"
                            placeholder=""
                            value={values.firstname}
                            onChange={handleChange}
                            style={{ margin: "0px 0px" }}
                        />
                        {errors.firstname && (
                            <p id="SignUp-firstname-error">
                                {errors.firstname}
                            </p>
                        )}
                    </div>

                    <div
                        className="flex flex-wrap flex-col"
                        style={{ gridColumn: Mobile ? "1 / -1" : "span 1" }}
                    >
                        <label htmlFor="Veritylastname" style={labelStyle}>
                            Last Name*
                        </label>
                        <input
                            disabled={isDisabled}
                            id="Veritylastname"
                            type="text"
                            name="lastname"
                            className="SignUp-form-input w-full !ml-0"
                            placeholder=""
                            value={values.lastname}
                            onChange={handleChange}
                            style={{ margin: "0px 0px" }}
                        />

                        {errors.lastname && (
                            <p id="SignUp-lastname-error">{errors.lastname}</p>
                        )}
                    </div>

                    <div
                        className="flex flex-wrap flex-col"
                        style={{ gridColumn: Mobile ? "1 / -1" : "span 2" }}
                    >
                        <label htmlFor="dob" style={labelStyle}>
                            Birthdate*
                        </label>
                        <DatePicker
                            portalId="root-portal"
                            className="SignUp-ReactDatePicker"
                            style={{ marginLeft: "2rem" }}
                            dateFormat="dd/MM/yyyy"
                            onChange={(date) => handleDateChange(date)}
                            selected={birthdate}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            placeholderText="DD/MM/YYYY"
                        />
                        {errors.birthday && (
                            <p id="SignUp-dob-error">{errors.birthday}</p>
                        )}
                    </div>

                    <div
                        className="flex flex-wrap flex-col"
                        style={{ gridColumn: Mobile ? "1 / -1" : "span 1" }}
                    >
                        <label htmlFor="password" style={labelStyle}>
                            Password*
                        </label>
                        <div className="relative">
                            <input
                                disabled={isDisabled}
                                id="password"
                                type={passwordShown ? "text" : "password"}
                                name="password"
                                className="SignUp-form-input w-full !ml-0"
                                placeholder=""
                                value={values.password}
                                onChange={handleChange}
                                style={{ margin: "0px 0px" }}
                            />
                            <BsEyeFill
                                className="signUp-eye-password absolute right-0 top-0"
                                fill="grey"
                                onClick={togglePassword}
                            />
                        </div>

                        {errors.password && (
                            <p id="SignUp-pass-error">{errors.password}</p>
                        )}
                    </div>

                    <div
                        className="flex flex-wrap flex-col"
                        style={{ gridColumn: Mobile ? "1 / -1" : "span 1" }}
                    >
                        <label htmlFor="confirmPassword" style={labelStyle}>
                            Confirm Password*
                        </label>
                        <div className="relative">
                            <input
                                disabled={isDisabled}
                                id="confirmPassword"
                                type={
                                    confirmPasswordShown ? "text" : "password"
                                }
                                name="confirmPassword"
                                className="SignUp-form-input w-full !ml-0"
                                placeholder=""
                                value={values.confirmPassword}
                                onChange={handleChange}
                                style={{ margin: "0px 0px" }}
                            />
                            <BsEyeFill
                                className="signUp-eye-confirmPass absolute right-0 top-0"
                                fill="grey"
                                onClick={toggleConfirmPassword}
                            />
                        </div>

                        {errors.confirmPassword && (
                            <p id="SignUp-confirmPass-error">
                                {errors.confirmPassword}
                            </p>
                        )}
                    </div>
                </div>

                <div className="flex flex-col gap-2">
                    <div className="flex items-baseline gap-3">
                        <CheckboxVerity
                            disabled={isDisabled}
                            id="promo"
                            type="checkbox"
                            name="promotionalMailAccepted"
                            className="checkboxVerity"
                            checked={values.promotionalMailAccepted}
                            onChange={handleChange}
                            required={false}
                            style={{ flexShrink: 0 }}
                        />
                        <label
                            htmlFor="promo"
                            style={{ color: "var(--color-th)" }}
                        >
                            I would like to receive exclusive member offers,
                            account updates, program and hotel news via email.
                        </label>
                    </div>

                    <div className="flex items-baseline gap-3">
                        <CheckboxVerity
                            disabled={isDisabled}
                            id="terms"
                            type="checkbox"
                            name="termsAccepted"
                            className="checkboxVerity"
                            checked={values.termsAccepted}
                            onChange={handleChange}
                            required={true}
                            style={{ flexShrink: 0 }}
                        />
                        <label
                            htmlFor="terms"
                            style={{ color: "var(--color-th)" }}
                        >
                            I have read and accept the{" "}
                            <a
                                href={termsFileUri}
                                target="_blank"
                                rel="noreferrer noopener"
                                className="signUpConditions"
                                style={{
                                    color: `${buttonBackgroundColor}`,
                                }}
                            >
                                Terms & Conditions*
                            </a>
                        </label>
                    </div>
                </div>

                <span className="">
                    <i>
                        Points are credited only to Loyalty members who have a
                        valid reservation under their name.
                    </i>
                </span>

                <div className="">
                    <button
                        ref={buttonRef}
                        style={style}
                        disabled={isDisabled}
                        className="SignUpFormButton"
                        type="submit"
                    >
                        Register
                    </button>
                </div>
            </form>
        </>
    );
}

export default SignUpForm;
